<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import { useI18n } from 'vue-i18n';
    import TaskTemplateForm from './TaskTemplateForm.vue';
    import AddButton from '@/components/AddButton.vue';
    import { ref } from 'vue';
    import QueryKey from '@/enums/QueryKey';

    const { t } = useI18n();

    const taskTemplateForm = ref<InstanceType<typeof TaskTemplateForm>>();

    const form = useForm({
        name: '',
        description: '',
        tasks: [],
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.task-templates.store')"
        :query-key="[QueryKey.TASK_TEMPLATES]"
        title="task-templates.create"
        button-text="task-templates.create"
        modal-size="sm:max-w-3xl"
    >
        <TaskTemplateForm
            ref="taskTemplateForm"
            :form="form"
        />
        <template #footerActions>
            <AddButton
                class="mr-auto"
                @click.prevent="taskTemplateForm?.addTask()"
            >
                {{ t('task-templates.add_task') }}
            </AddButton>
        </template>
    </DialogForm>
</template>
